<template>
    <v-main>
        <v-container fluid> 
            <v-row>
                <v-col>
                    <div class="maps-wrapper">
                        <div class="control">
                            <div class="pt-6 px-3 border-right font-weight-bold">
                                Satellite
                                <v-switch v-model="viewSatellite" class="mt-0" />
                            </div>     
                            <div class="pt-6 px-3 border-right font-weight-bold" v-if="isAdmin">
                                <v-select v-model="agent" :items="agents" item-value="gebr_code" item-text="gebr_naam" label="Select an agent" :multiple="true" clearable dense></v-select>
                            </div>                             
                        </div>
                        <v-card class="legend" :width="legendWidth">
                            <div>
                                <v-row class="ma-0 pa-0" v-if="isAdmin&&showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="telephone">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr 2">Telephone List</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewTelephone" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="isAdmin&&showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="deduplicate">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Deduplicate List</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewDeduplicate" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="isAdmin&&showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="assign">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Assign List</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewAssign" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="leads">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Leads</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewLeads" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="nurtured">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Nurtured</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewNurtured" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="host">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Host VfY</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewHost" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0" v-if="showLegend">
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><div class="huis">&nbsp;</div></v-col>
                                    <v-col cols="8" class="ma-0 pa-0 pt-2 pr-2">Acco VfY</v-col>
                                    <v-col cols="2" class="ma-0 pa-0 pt-2 pr-2"><v-switch v-model="viewHuis" class="ma-0 pa-0"/></v-col>
                                </v-row>
                                <v-divider v-if="showLegend"></v-divider >
                                <v-row>
                                    <v-col cols="12" class="pt-4"><v-btn class="primary" x-small @click="toggleLegend">{{ legendText }}</v-btn></v-col>
                                </v-row>
                            </div>
                        </v-card>
                        <v-card class="count">
                            <div>
                            <v-row class="ma-0 pa-0" v-if="showCount">
                                <v-col cols="12" class="ma-0 pa-0 pt-2 pr-2 font-weight-bold">
                                    Houses are only shown if coordinates are entered
                                </v-col>
                            </v-row>
                            <v-row class="ma-0 pa-0" v-if="showCount">
                                <v-col cols="12" class="ma-0 pa-0 pt-2 pr-2">
                                    There are {{ selectedMarkers }} locations in the selection<br>
                                    There are {{ leadNoMarkers }} leads without coordinates<br>
                                    There are {{ hostNoMarkers }} hosts without coordinates<br>
                                    <!-- There are {{ huisNoMarkers }} accommodations without coordinates -->
                                </v-col>
                            </v-row>
                            <v-divider v-if="showCount"></v-divider >
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" x-small @click="toggleCount" v-if="showCount">Hide</v-btn>
                                <v-btn class="primary" x-small @click="toggleCount" v-if="!showCount">Show Count</v-btn>                                   
                            </v-card-actions>
                        </div>
                        </v-card>
                        <GmapMap ref="maps" class="maps" :options="mapOptions" :zoom="mapZoom" :center="mapCenter">
                            <mapMarker :markers="leadMarkers"        :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                            <mapMarker :markers="nurturedMarkers"    :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                            <mapMarker :markers="telephoneMarkers"   :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                            <mapMarker :markers="deduplicateMarkers" :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                            <mapMarker :markers="hostMarkers"        :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                            <mapMarker :markers="huisMarkers"        :openedMarkerId="openedMarkerId" @openInfo="openInfo"/>
                        </GmapMap>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!-- Navbar -->
        <navbarPten menuIndex="1" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    // Assets
    import leadMarkerIcon from "@/assets/maps-marker-lead.svg";
    import nurturedMarkerIcon from "@/assets/maps-marker-nurtured.svg";
    import telephoneMarkerIcon from "@/assets/maps-marker-telephone.svg";
    import deduplicateMarkerIcon from "@/assets/maps-marker-deduplicate.svg";
    import assignMarkerIcon from "@/assets/maps-marker-assign.svg";
    import hostMarkerIcon from "@/assets/maps-marker-host.svg";
    import huisMarkerIcon from "@/assets/maps-marker-huis.svg";
    // Components
    import navbarPten from '@/components/pten/navbarPten.vue';
    import mapMarker from "@/components/pten/mapMarker.vue";

    export default {
        components: {
            navbarPten,
            mapMarker,
        },
        data() {
            return {
                isAdmin: false,
                agents: [],
                agent: "",
                last: "",

                showLegend: true,
                legendText: "hide markers",
                legendWidth: 220,
                showCount: true,

                missing_coordinates: 0,

                // Active leads
                viewLeads: false,
                leadMarkers: [],
                leadMarkersKeep: [],
                leadNoCoord: 0,

                // Nurtured leads
                viewNurtured: false,
                nurturedMarkers: [],
                nurturedMarkersKeep: [],
                nurturedNoCoord: 0,

                // Telephone list
                viewTelephone: false,
                telephoneMarkers: [],
                telephoneMarkersKeep: [],
                telephoneNoCoord: 0,

                
                // Deduplicate list
                viewDeduplicate: false,
                deduplicateMarkers: [],
                deduplicateMarkersKeep: [],
                deduplicateNoCoord: 0,

                // Assign list
                viewAssign: false,
                assignMarkers: [],
                assignMarkersKeep: [],
                assignNoCoord: 0,

                // Host list
                viewHost: false,
                hostMarkers: [],
                hostMarkersKeep: [],
                hostNoCoord: 0,

                // Huis list
                viewHuis: false,
                huisMarkers: [],
                huisMarkersKeep: [],
                huisNoCoord: 0,
                
                // Only ove marker, shared with Lead/Nurtured
                openedMarkerId: "",

                heightCorrection: 250,
                wInnerHeight: window.innerHeight - this.heightCorrection,
                mapCenter: {lat: 48.040718, lng: 5.860905}, 
                mapZoom: 5,

                viewSatellite: false,

                mapOptions: {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy',
                    styles: [{
                        featureType: 'poi',
                        elementType: 'labels',
                        stylers: [
                            { visibility: 'off' } // Hide all default poi labels
                        ]
                    }],
                    zoomControlOptions: {
                        position: 1 // Position top left
                    }
                },
            }  
        },
        computed: {
            screensize: function () {
                return this.$vuetify.breakpoint.name;
            },
            selectedMarkers: function () {
                let total = 0;
                if (this.viewLead) {
                    total += this.leadMarkers.length;
                }
                if (this.viewNurtured) {
                    total += this.nurturedMarkers.length;
                }
                if (this.viewTelephone) {
                    total += this.telephoneMarkers.length;
                }
                if (this.viewDeduplicate) {
                    total += this.deduplicateMarkers.length;
                }
                if (this.viewAssign) {
                    total += this.assignMarkers.length;
                }
                if (this.viewHost) {
                    total += this.hostMarkers.length;
                }
                if (this.viewHuis) {
                    total += this.huisMarkers.length;
                }
                return total;
            },
            leadNoMarkers: function () {
                let total = 0;
                total += this.leadNoCoord;
                total += this.nurturedNoCoord;
                total += this.telephoneNoCoord;
                total += this.deduplicateNoCoord;
                total += this.assignNoCoord;
                return total;
            },
            hostNoMarkers: function () {
                return this.hostNoCoord;
            },
            huisNoMarkers: function () {
                return this.huisNoCoord;
            },
        },
        mounted() {
            document.title = "ARES Leads";
            this.getPtenMapData();
        },
        watch: {
            agent() {
                this.addHuisMarkersToMap(this.viewHuis);
                this.addHostMarkersToMap(this.viewHost);
                this.addNurturedMarkersToMap(this.viewNurtured);
                this.addTelephoneMarkersToMap(this.viewTelephone);
                this.addDeduplicateMarkersToMap(this.viewDeduplicate);
                this.addAssignMarkersToMap(this.viewAssign);
                this.addLeadMarkersToMap(this.viewLeads);
            },
            viewLeads(value) {
                this.addLeadMarkersToMap(value);
            },
            viewNurtured(value) {
                this.addNurturedMarkersToMap(value);
            },
            viewTelephone(value) {
                this.addTelephoneMarkersToMap(value);
            },
            viewDeduplicate(value) {
                this.addDeduplicateMarkersToMap(value);
            },
            viewAssign(value) {
                this.addAssignMarkersToMap(value);
            },
            viewHost(value) {
                this.addHostMarkersToMap(value);
            },
            viewHuis(value) {
                this.addHuisMarkersToMap(value);
            },
            viewSatellite(value) {
                if (value) {
                    this.$refs.maps.$mapObject.setMapTypeId('satellite');
                } else {
                    this.$refs.maps.$mapObject.setMapTypeId('roadmap');
                }
            },
        },
        methods: {
            getPtenMapData() {
                this.$axios.post("ares/json/ares/pten/getPtenMapData.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenMapData"
                    },
                    getPtenMapData: {
                        agent: this.agent === null ? "" : this.agent,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.isAdmin = res.data.getPtenMapData.isAdmin;
                        this.agents = res.data.getPtenMapData.gebr_codeKeuzes;
                        this.agent = res.data.getPtenMapData.agent;
                        this.missing_coordinates = res.data.getPtenMapData.missing_coordinates;
                        this.leadMarkersKeep = this.createMarkers(res.data.getPtenMapData.leads, leadMarkerIcon);
                        this.nurturedMarkersKeep = this.createMarkers(res.data.getPtenMapData.nurtured, nurturedMarkerIcon);
                        this.telephoneMarkersKeep = this.createMarkers(res.data.getPtenMapData.telephone, telephoneMarkerIcon);
                        this.deduplicateMarkersKeep = this.createMarkers(res.data.getPtenMapData.deduplicate, deduplicateMarkerIcon);
                        this.assignMarkersKeep = this.createMarkers(res.data.getPtenMapData.assign, assignMarkerIcon);
                        this.hostMarkersKeep = this.createMarkersHost(res.data.getPtenMapData.host, hostMarkerIcon);
                        this.huisMarkersKeep = this.createMarkersHuis(res.data.getPtenMapData.huis, huisMarkerIcon);
                        this.centerMap();

                        // This will force adding the markers to the map
                        this.viewHost = true;
                        this.viewHuis = true;
                        this.viewLeads = true;
                        this.viewNurtured = false;
                        this.viewTelephone = false;
                        this.viewDeduplicate = false;
                        this.viewAssign = false;

                    }
                });
            },
            createMarkers(markerData, markerIcon) {
                let newMarkers = []
                for (let i = 0; i < markerData.length; i++) {
                    newMarkers.push({
                        marker_id: markerData[i].pten_code,
                        marker_encrid: markerData[i].pten_encrid,
                        marker_name: markerData[i].pten_name,
                        marker_status_oms: markerData[i].pten_status_oms,
                        marker_agent: markerData[i].pten_agent,
                        marker_agent_oms: markerData[i].pten_agent_oms,
                        marker_type: "lead",
                        position: {
                            lat: parseFloat(markerData[i].pten_lat),
                            lng: parseFloat(markerData[i].pten_lng)
                        },
                        options: {
                            icon: markerIcon,
                        }
                    })
                }
                return newMarkers;
            },
            createMarkersHost(markerData, markerIcon) {
                let newMarkers = []
                for (let i = 0; i < markerData.length; i++) {
                    newMarkers.push({
                        marker_id: markerData[i].eign_code,
                        marker_encrid: markerData[i].eign_encrid,
                        marker_name: markerData[i].eign_name,
                        marker_status_oms: markerData[i].eign_status_oms,
                        marker_agent: markerData[i].eign_agent,
                        marker_agent_oms: markerData[i].eign_agent_oms,
                        marker_type: "host",
                        position: {
                            lat: parseFloat(markerData[i].eign_lat),
                            lng: parseFloat(markerData[i].eign_lng)
                        },
                        options: {
                            icon: markerIcon,
                        }
                    })
                }
                return newMarkers;
            },
            createMarkersHuis(markerData, markerIcon) {
                let newMarkers = []
                for (let i = 0; i < markerData.length; i++) {
                    newMarkers.push({
                        marker_id: markerData[i].huis_code,
                        marker_encrid: markerData[i].huis_encrid,
                        marker_name: markerData[i].huis_name,
                        marker_status_oms: markerData[i].huis_status,
                        marker_agent: markerData[i].huis_agent,
                        marker_agent_oms: markerData[i].huis_agent_oms,
                        marker_type: "huis",
                        position: {
                            lat: parseFloat(markerData[i].huis_lat),
                            lng: parseFloat(markerData[i].huis_lng)
                        },
                        options: {
                            icon: markerIcon,
                        }
                    })
                }
                return newMarkers;
            },
            addMarkersToMap(value, markers, allMarkers, noCoord, isAgent) {
                if (!value) {
                    this[markers] = [];
                    this[noCoord] = 0;
                    return;
                }
                console.log(this.agent);
                if ((!this.isAdmin) || this.agent === null || this.agent === "" || this.agent.length === 0) {
                    this[markers] = this[allMarkers];
                    this.doCountMarkers(markers, noCoord);
                    return;
                }
                this[markers] = [];
                for (let i = 0; i < this[allMarkers].length; i++) {
                    if (this.agent.includes(this[allMarkers][i].marker_agent) || !isAgent) {
                        this[markers].push(this[allMarkers][i]);
                    }
                }
                this.doCountMarkers(markers, noCoord);
            },
            addLeadMarkersToMap(value) {
                this.addMarkersToMap(value, "leadMarkers", "leadMarkersKeep", "leadNoCoord", true);
            },
            addNurturedMarkersToMap(value) {
                this.addMarkersToMap(value, "nurturedMarkers", "nurturedMarkersKeep", "nurturedNoCoord", true);
            },
            addTelephoneMarkersToMap(value) {
                this.addMarkersToMap(value, "telephoneMarkers", "telephoneMarkersKeep", "telephoneNoCoord", false);
            },
            addDeduplicateMarkersToMap(value) {
                this.addMarkersToMap(value, "deduplicateMarkers", "deduplicateMarkersKeep", "deduplicateNoCoord", false);
            },
            addAssignMarkersToMap(value) {
                this.addMarkersToMap(value, "assignMarkers", "assignMarkersKeep", "assignNoCoord", false);
            },
            addHostMarkersToMap(value) {
                this.addMarkersToMap(value, "hostMarkers", "hostMarkersKeep", "hostNoCoord", true);
            },
            addHuisMarkersToMap(value) {
                this.addMarkersToMap(value, "huisMarkers", "huisMarkersKeep", "huisNoCoord", true);
            },
            changeMapType() {
                if (this.viewType === 'roadmap') {
                    this.$refs.map.setMapTypeId('satellite');
                } else {
                    this.$refs.map.setMapTypeId('roadmap');
                }
            },
            centerMap() {
                this.mapCenter = {lat: 48.040718, lng: 5.860905};
                this.mapZoom = 5;
            },
            openInfo(id) {
                this.openedMarkerId = id
            },
            toggleLegend() {
                this.showLegend = !this.showLegend;
                if (this.showLegend) {
                    this.legendText = "hide markers";
                    this.legendWidth = 220;
                }else {
                    this.legendText = "markers";
                    this.legendWidth = 85;
                }
            },
            toggleCount() {
                this.showCount = !this.showCount;
            },
            doCountMarkers(markers, noCoord) {
                let iTemp = 0;
                for (let i = 0; i < this[markers].length; i++) {
                    if (this[markers][i].position.lat === 0 && this[markers][i].position.lng === 0) {
                        iTemp += 1;
                    }
                }
                // Trigger computed value only one time, not during counting!!!
                this[noCoord] = iTemp;
            },
            actionClick(action) {
                switch (action) {
                    default:
                        break;
                }
            },
        }
    };
</script>

<style scoped>
    .maps-wrapper {
        position: relative;
    }
    .control {
        position: absolute;
        top: 10px;
        left: 50px;
        height: 81px;
        /* width: 450px; */
        z-index: 1;
        background-color: white;
        border-left: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
    }
    .legend {
        position: absolute;
        padding: 5px;
        bottom: 10px;
        left: 10px;
        /* height: 81px; */
        /* width: 220px; */ 
        z-index: 1;
        background-color: white;
        border-left: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
    }
    .count {
        position: absolute;
        padding: 5px;
        top: 10px;
        right: 10px;
        /* height: 81px; */
        /* width: 220px; */
        z-index: 1;
        background-color: white;
        border-left: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
    }
    .telephone {
        background-color: #0000ff;
        border: 1px solid #000000;
    }
    .deduplicate {
        background-color: #2196f3;
        border: 1px solid #000000;
    }
    .assign {
        background-color: #00E9FF;
        border: 1px solid #000000;
    }
    .leads {
        background-color: #4C2750;
        border: 1px solid #000000;
    }
    .nurtured {
        background-color: #ff5500;
        border: 1px solid #000000;
    }
    .host {
        background-color: #C99300;
        border: 1px solid #000000;
    }
    .huis {
        background-color: #00FF00;
        border: 1px solid #000000;
    }
    .maps {
        width: 100%;
        height: calc(100vh - 140px);
    }
    .select {
      width: 60px;
      max-height: 60px;
      font-size: 11px;
    }
</style>